import * as React from "react";
import {
  Stack,
  RadioGroup,
  TextLink,
  Radio,
  Alert,
  List,
  ListItem,
  Text,
} from "@origin-digital/ods-core";
import { FieldProps, useField } from "formik";

/**
 * Customised `component` for a formik field.
 * Focus on presentation from Playroom
 * @param props
 * @returns
 */
const FieldComponent = (props: FieldProps) => {
  const {
    field: { name: fieldName },
    form: { setFieldValue },
  } = props;
  const [input, meta] = useField(fieldName);
  const { value } = input;
  const radioGroupValue = React.useMemo(() => {
    if (value === true) {
      return "yes";
    } else if (value === false) {
      return "no";
    } else {
      return undefined;
    }
  }, [value]);

  return (
    <>
      {/* Life support */}
      <Stack space={["large", "xlarge"]}>
        <RadioGroup
          label={
            (
              <Text>
                Is anyone who lives (or plans to live) at the property on{" "}
                <TextLink
                  href={"https://www.originenergy.com.au/life-support/"}
                >
                  life support
                </TextLink>
                ?
              </Text>
            ) as unknown as string
          }
          name="life-support"
          error={!!meta.error}
          helperText={meta.error}
          value={radioGroupValue}
          onChange={(_, fieldValue) => {
            setFieldValue(fieldName, fieldValue === "yes");
          }}
          // Not support by ODS v2
          // hideHelperTextSpace={true}
        >
          <Radio id="yes" label="Yes" value="yes" />
          <Radio id="no" label="No" value="no" />
        </RadioGroup>
        {radioGroupValue === "yes" && <AlertForYes />}
      </Stack>
      {/* End Life support */}
    </>
  );
};

const AlertForYes = () => (
  <Alert title="Important information for life support customers">
    <Stack space="medium">
      <Text>
        Registering for life support with Origin for the first time at this
        property with this energy type:
      </Text>
      <List space="xsmall">
        <ListItem>
          We'll send you information on how to register your premises as
          requiring life support, including how to provide valid medical
          confirmation
        </ListItem>
        <ListItem>
          Once it has been signed by a registered medical practitioner, return
          your medical confirmation to us so we have a record of your life
          support requirements
        </ListItem>
        <ListItem>
          Your contact details, including email address, will be sent to the
          distributor for the purpose of life support requirements, such as
          outage notifications. If you want the contact details to be changed,
          please contact Origin.
        </ListItem>
      </List>
      <Text>
        Please contact us on{" "}
        <TextLink href="mailto:NCOrigin@origin.com.au">
          NCOrigin@origin.com.au
        </TextLink>{" "}
        for any questions regarding your life support requirements.
      </Text>
    </Stack>
  </Alert>
);

export default FieldComponent;
